import type { ObjectValuesAsTypes } from "utils/types";

export const PRODUCT_FLAGS = {
  CIRCUIT_BREAKER: "circuitBreaker",
  CONNECT: "connect",
  CONNECT_REFUND: "connectRefund",
  CONNECT_PAYOUTS: "connectPayouts",
  CONNECT_OPEN_LOOP_PAYOUTS: "connectOpenLoopPayouts",
  GATEWAY: "gateway",
  PAY_BY_LINK: "payByLink",
  TRANSFORMER: "transformer",
  VERIFY: "verify",
  GATEWAY_AUSTRALIA: "gatewayAustralia",
  GATEWAY_US: "gatewayUs",
  MATCHMETER: "matchmeter",
} as const;

export type ProductFlagsType = ObjectValuesAsTypes<typeof PRODUCT_FLAGS>;

export const allProductFlags = Object.values(
  PRODUCT_FLAGS
) as ProductFlagsType[];

export type ProductEnvironmentFlags = Record<ProductFlagsType, boolean>;

export interface ProductFlags {
  production: ProductEnvironmentFlags;
  sandbox: ProductEnvironmentFlags;
}

export interface ProductFlag {
  id: ProductFlagsType;
  production: boolean;
  sandbox: boolean;
}
